import { track } from '@pegasus/abtesting';
import { Tracker } from '@pegasus/tracker';
class BrowsingTracker extends Tracker {
    constructor() {
        super(...arguments);
        this.trackExperimentOnLoad = (experiment) => {
            if (experiment.mode === 'TEST' || experiment.mode === 'FORCED') {
                // More details about frontend tracking can be found here:
                // https://experimentation.docs.zalando.net/howto/integrate-with-octopus/#front-end-tracking
                track(experiment);
            }
        };
    }
}
export const tracker = new BrowsingTracker();
